module.exports = __webpack_public_path__ + "img/five02.17cf7966.png";